// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardPage_wrapper__rcrf+","dashboardContainer":"DashboardPage_dashboardContainer__UQrPz"};